import script from "./VaultsListItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./VaultsListItem.vue?vue&type=script&setup=true&lang=ts"

import "./VaultsListItem.vue?vue&type=style&index=0&id=1af0540c&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/curl-fe-build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1af0540c"]])

export default __exports__